module.exports = __webpack_public_path__ + "static/media/26UNRWA1.9671c22e.jpg";